import { ReduxStore } from 'store/types';

function getAllEmptyMessage(state: ReduxStore): string {
  return state.category.getAll.config.emptyMessage;
}

export default getAllEmptyMessage;
